/* =============================================================================
   mkv4-fit-help.js — PATCH 38 (2026-05-30)
   -----------------------------------------------------------------------------
   Injecte une phrase d'aide juste apres le selecteur vehicule (matrikar-vehicle-fit).
   Auto-scope : si #mkvfit-wrap n'existe pas (produits no-vehicle-fit : organizer,
   petshield, backseat), le script ne fait rien.
   N'altere PAS la logique du snippet matrikar-vehicle-fit (insertion APRES).
   Idempotent : .mkv4-fit-help check evite la double insertion.
   ============================================================================= */
(function () {
  function inject() {
    var wrap = document.getElementById('mkvfit-wrap');
    if (!wrap) return;
    if (document.querySelector('.mkv4-fit-help')) return;
    var p = document.createElement('p');
    p.className = 'mkv4-fit-help';
    var I = window.MK_I18N || {};
    p.innerHTML =
      (I.fithelp_prefix || "Can't find your model or have a question? ") +
      '<a href="/pages/contact-us">' + (I.fithelp_contact || 'Contact us') + '</a>.';
    wrap.insertAdjacentElement('afterend', p);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', inject);
  } else {
    inject();
  }
  /* Filet de securite : si matrikar-vehicle-fit re-rend son contenu apres
     un changement d'etat (selection / change), on tente une re-injection. */
  document.addEventListener('matrikar:vehicleSelected', inject);
  document.addEventListener('matrikar:vehicleChanged', inject);

  /* FIX 2026-07-16 — le texte d'aide disparaissait apres un swatch couleur, sur TOUTES les PDP.
     Cause : ce <p> est insere en FRERE de #mkvfit-wrap (insertAdjacentElement('afterend')).
     Le swap fait `root.innerHTML = fresh` sur .shopify-section--main-product (mkv5-pdp.js) :
     mkv5-pdp PRESERVE le noeud #mkvfit-wrap lui-meme (il le re-insere), mais PAS ses freres
     -> le <p> etait detruit et jamais recree (les 2 events ci-dessus ne sont pas emis par un swap).
     mkv5-pdp dispatche 'variant:changed' juste apres le re-render -> on s'y raccroche.
     inject() est deja idempotent (garde .mkv4-fit-help) et no-op hors PDP a selecteur. */
  document.addEventListener('variant:changed', inject);

  /* Filet : si un re-render survient sans event (ordre/timing), l'observer rattrape.
     On observe la SECTION (son innerHTML change, mais le noeud HOTE survit) — observer un
     noeud interne serait inutile : il est detruit par le re-render, et l'observer resterait
     accroche a un noeud detache (c'est exactement le defaut des STEP labels trunk/seat).
     PAS DE BOUCLE : le <p> insere est bien DANS la zone observee, donc l'observer se
     redeclenche une fois — mais inject() sort immediatement grace a sa garde
     `.mkv4-fit-help` (aucune nouvelle mutation) -> le cycle s'arrete. */
  try {
    var host = document.querySelector('.shopify-section--main-product');
    if (host && 'MutationObserver' in window) {
      var t = null;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(inject, 120); })
        .observe(host, { childList: true, subtree: true });
    }
  } catch (e) {}
})();
